import { Box, Chip, chipClasses } from "@mui/material";
import { AnglerEvents, AnglerTagSettings } from "../../AnglerUtils";

interface AnglerTagsProps {
  settings: AnglerTagSettings;
  onToggle: (name: AnglerEvents) => void;
  amounts: Record<AnglerEvents, number>;
}

const AnglerTags = ({ settings, onToggle, amounts }: AnglerTagsProps) => {
	const keys = Object.keys(settings) as AnglerEvents[];
	return (
		<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
			{keys.map((key) => {
				const item = settings[key];
				return (
					<Chip
						key={key}
						icon={item.icon}
						label={`${item.label} ${amounts[key] > 0 ? ` (${amounts[key]})` : ""}`}
						onClick={() => onToggle(key)}
						variant="filled"
						size="small"
						sx={{
							backgroundColor: item.color,
							color: "#fff",
							fontSize: 12,
							fontWeight: 500,
							opacity: item.visible ? 1 : 0.3,

							"&:hover": {
								backgroundColor: item.color,
								opacity: item.visible ? 0.9 : 0.4,
							},

							[`& .${chipClasses.icon}`]: {
								color: "#FFF",
								fontSize: 14,
								ml: 1,
							},
						}}
					/>
				);
			})}
		</Box>
	);
};

export default AnglerTags;
